/**
 * Build-time feature flags (Vite env, inlined into each app's bundle).
 *
 * `VITE_FEATURE_CONTRACTS` switches the Contracts tab and route (ADR-0054):
 * unset means ON (DEV and local runs are unchanged); "0", "false", "off" or "no"
 * (any case) mean OFF — the PROD Pages deploys in .github/workflows/ci.yml set
 * "0". The server has the matching `FEATURE_CONTRACTS` (docs/deploy.md "PROD").
 */
export function featureFlagOn(raw: string | undefined): boolean {
  const v = (raw ?? '').trim().toLowerCase();
  return !(v === '0' || v === 'false' || v === 'off' || v === 'no');
}
